import {
  message,
  PageHeader,
  Space,
  Tag,
  Select,
} from "antd";
import { ThunderboltOutlined } from "@ant-design/icons";
import './FacturaGlobalAnim.css';
import axios from "axios";
import React, { Component } from "react";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { MensajeError, ButtonItem, DatePickerItem, Form, FormItem, ModalItem, SelectItem, SwitchItem, TableItem, dineroDisabledMask  } from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import facturaGlobalPdf from "../../../../Pdf/facturaGlobalPdf";
import MandarCorreoFacturaGlobal from "../MandarCorreoFacturaGlobal/MandarCorreoFacturaGlobal";
import dayjs from "dayjs";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
const { Option } = Select

moment.locale("es");

class FacturaGlobal extends Component {
  formRef = React.createRef();
  state = {
    todasVentas: [],
    loading: false,
    modalCancelacion: false,
    modalCancelacionId: null,
    modalEnvios: false,
    modalEnviosId: null,
    objetoProyectos: null,
    todasProyectos: [],
    objetoMesesSat: null,
    todasMesesSat: [],
    objetoPeriocidadesSat: null,
    todasPeriocidadesSat: [],
    ventasSeleccionadas: [],
    autoSelectedIds: [],
    autoSelecting: false,
    subtotal: 0,
    total: 0,
    modalDatosFacturaGlobal: 0,
    filtrosProyectos: [],
    modalVerFacturaGlobal: false,
    modalVerFacturaGlobalId: null,
    predefinirGlobalPorLineaVenta: true
  };
  componentDidMount() {
    this.consultarDatosFacturaGlobal();
  }

  consultarDatosFacturaGlobal() {
    this.setState({ loading: true });
    axios
      .post(
        "ventas/selectDatosFacturaGlobal",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          let filtrosProyectos = res.data.proyectos.map(valueProyecto => {
            return {
              text: valueProyecto.nombre,
              value: valueProyecto._id.toString()
            }
          })
          let filtrosFormasPago = res.data.formasDePago?.map(valueFormaPago => {
            return {
              text: valueFormaPago.c_FormaPago + ' - ' + valueFormaPago.descripcion,
              value: valueFormaPago._id.toString()
            }
          })
          const predefinirGlobalPorLineaVenta = res.data.predefinirGlobalPorLineaVenta ?? true;
          this.formRef.current?.setFieldsValue({ lineaPorVenta: predefinirGlobalPorLineaVenta });

          const ventasMapeadas = res.data.ventas.map((value) => {
            let numero = ''
            if (value.remision) {
              numero += (value.remisionSerie ? value.remisionSerie : 'R') + ' ' + value.remisionNumero
            }
            if (value.factura) {
              if (numero !== '') {
                numero += ' '
              }
              numero += (value.facturaSerie ? value.facturaSerie : 'F') + ' ' + value.facturaNumero
            }
            return {
              ...value,
              fechaVenta: value.fechaFactura
                ? value.fechaFactura
                : value.fechaRemision,
              numero: numero,
              moneda: value.moneda.abreviacion,
              cliente: (value.cliente.persona ? value.cliente.razonSocial : (value.cliente.nombre + ' ' + value.cliente.apellidoPaterno + ' ' + value.cliente.apellidoMaterno)) + " - " + value.cliente.rfc,
            };
          });

          this.setState({
            predefinirGlobalPorLineaVenta,
            objetoProyectos: res.data.proyectos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoMesesSat: res.data.mesesSat.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.Clave + ' - ' + value.Descripcion}
                </Option>
              );
            }),
            objetoPeriocidadesSat: res.data.periocidadesSat.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.Clave + ' - ' + value.Descripcion}
                </Option>
              );
            }),
            todasVentas: ventasMapeadas,
            todasProyectos: res.data.proyectos,
            todasMesesSat: res.data.mesesSat,
            todasPeriocidadesSat: res.data.periocidadesSat,
            filtrosProyectos,
            filtrosFormasPago
          });

          // Pre-seleccionar ventas si se viene desde el aviso de automatización
          const remisionesIds = this.props.location?.state?.remisionesIds;
          if (remisionesIds?.length) {
            const idsDisponibles = new Set(ventasMapeadas.map(v => v._id.toString()));
            const idsValidos = remisionesIds
              .map(id => id.toString())
              .filter(id => idsDisponibles.has(id));
            if (idsValidos.length) {
              this.setState({ autoSelecting: true });
              setTimeout(() => {
                this.onSelectChange(idsValidos);
                this.setState({ autoSelecting: false, autoSelectedIds: idsValidos });
              }, 2000);
            }
          }
        } else {
          message.error('Hubo un error y no se cargaron los datos')
        }
      });
  }

  atras() {
    this.props.history.goBack();
  }

  onSelectChange = (ventasSeleccionadas) => {

    let total = 0
    let subtotal = 0
    let monedaId
    let diferenteMoneda = false
    let ventaNoPagada = false
    const ventasFiltradas = []
    for (const valueVentaId of ventasSeleccionadas) {
      const venta = this.state.todasVentas.find(valueVentaTT => valueVentaTT._id.toString() === valueVentaId.toString())

      if (venta.contado === 1 && venta.totalPagado !== venta.totalPagar) {
        ventaNoPagada = true
        continue
      }

      ventasFiltradas.push(valueVentaId)

      if (!monedaId) {
        monedaId = venta.monedaId.toString()
        total += venta.totalPagar
        subtotal += venta.subtotal
      } else {

        if (monedaId !== venta.monedaId.toString()) {
          diferenteMoneda = true
        } else {

          total += venta.totalPagar
          subtotal += venta.subtotal
        }

      }
    }

    if (ventaNoPagada) {
      message.warning('Una venta no esta totalmente cobrada')
    }

    if (diferenteMoneda) {
      message.warning('Las ventas necesitan ser de la misma moneda')
      total = 0
      subtotal = 0
    }

    this.setState({ ventasSeleccionadas: ventasFiltradas, total, subtotal });
    if (ventasFiltradas.length === 1) {
      message.success(`Se ha seleccionado ${ventasFiltradas.length} venta`)
    } else if (ventasFiltradas.length > 1) {
      message.success(`Se han seleccionado ${ventasFiltradas.length} ventas`)
    }
  }

  abrirDatosFacturaGlobal() {
    if (this.state.ventasSeleccionadas.length > 0) {
      let monedaId
      let diferenteMoneda = false
      let modalDatosFacturaGlobal = false
      for (const valueVentaId of this.state.ventasSeleccionadas) {
        const venta = this.state.todasVentas.find(valueVentaTT => valueVentaTT._id.toString() === valueVentaId.toString())
        if (!monedaId) {
          monedaId = venta.monedaId.toString()
          modalDatosFacturaGlobal = true
        } else {

          if (monedaId !== venta.monedaId.toString()) {
            diferenteMoneda = true
            modalDatosFacturaGlobal = false
          } else {
            modalDatosFacturaGlobal = true
          }

        }
      }
      if (diferenteMoneda) {
        message.warning('Las ventas necesitan ser de la misma moneda')
      } else {
        this.setState({ modalDatosFacturaGlobal })
      }
    } else {
      message.warning('Selecciona al menos una venta para generar la factura global')
    }

  }

  cerrarDatosFacturaGlobal() {
    this.setState({ modalDatosFacturaGlobal: false })
  }

  onFinishFailed(e) {
    e.errorFields.map((value, index) => {
      if (e.errorFields[index].name[1] || e.errorFields[index].name[1] === 0) {
        message.error(
          "Error: " +
          e.errorFields[index].errors[0] +
          " en la fila " +
          (e.errorFields[index].name[1] + 1)
        );
      } else {
        message.error("Error: Falta un campo");
      }
      return null;
    });
  }
  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "ventas/agregarFacturaGlobal",
        {
          ...values,
          ventasIds: this.state.ventasSeleccionadas,
          empresaId: this.props.empresaId,
          avisoId: this.props.location?.state?.avisoId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha registrado una factura global");
          if (res.data.respuestaFactura.status === "success") {
            if (window.registrarMovimiento) {
              const dataSat = res.data.respuestaFactura.dataSat;
              const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'F') + ' - ' + dataSat.Folio;

              window.registrarMovimiento({
                titulo: 'Factura Emitida',
                mensaje: `${nombreArchivo} - Haga click para descargar`,
                icono: 2,
                onClick: () => {
                  var xmltext = res.data.respuestaFactura.data.cfdi;

                  var filename = nombreArchivo + ".xml";
                  var pom = document.createElement("a");
                  var bb = new Blob([xmltext], { type: "text/plain" });

                  pom.setAttribute("href", window.URL.createObjectURL(bb));
                  pom.setAttribute("download", filename);

                  pom.dataset.downloadurl = [
                    "text/plain",
                    pom.download,
                    pom.href,
                  ].join(":");
                  pom.draggable = true;
                  pom.classList.add("dragout");

                  pom.click();

                  const pdf = facturaGlobalPdf(res.data);

                  pdfMake.createPdf(pdf).download(nombreArchivo + '.pdf');
                },
              });
            }

            this.setState({
              modalVerFacturaGlobal: true,
              modalVerFacturaGlobalId: res.data.facturaGlobalId,
            });
          }
        } else if (res.data.success === 1) {
          MensajeError({
            message: res.data.errorTimbrado?.titulo || res.data.message || "No se pudo registrar la factura global",
            description: res.data.errorTimbrado?.mensaje || res.data.description,
            detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
          });
        } else {
          message.error("Hubo un error y la factura global no se registro");
        }
      });
  }

  cerrarMandarCorreoFacturaGlobal() {
    this.setState({
      modalVerFacturaGlobal: false,
      modalVerFacturaGlobalId: null,
    });
    this.atras();
  }

  render() {
    const columns = [
      {
        title: "R / OC",
        dataIndex: "numero",
        key: "numero",
        buscar: "numero",
        sorter: true,
        render: (_, record) => (
          <div>
            <div style={{ fontSize: "12px"}}>
             {record.numero}
            </div>
           {record.ordenDeCompra && (
              <div style={{ fontSize: "12px", color: "#666" }}>
                OC: {record.ordenDeCompra}
              </div>
            )}
          </div>
        ),
        width: 100,
        ellipsis: true,
      },
      {
        title: "OC",
        dataIndex: "ordenDeCompra",
        key: "ordenDeCompra",
        buscar: "ordenDeCompra",
        responsive: [],
        width: 0,
      },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        key: "proyecto",
        filters: this.state.filtrosProyectos,
        sorter: (a, b) => {
          if (a.proyecto.nombre < b.proyecto.nombre) {
            return -1;
          }
          if (a.proyecto.nombre > b.proyecto.nombre) {
            return 1;
          }
          return 0;
        },
        render: (value) => value.nombre,
        onFilter: (value, record) => record.proyectoId.toString().indexOf(value) === 0,
        width: 160,
        ellipsis: true,
      },
      {
        title: "Cliente",
        dataIndex: "cliente",
        key: "cliente",
        sorter: (a, b) => {
          if (a.cliente < b.cliente) {
            return -1;
          }
          if (a.cliente > b.cliente) {
            return 1;
          }
          return 0;
        },
        width: 200,
        buscar: "cliente",
        ellipsis: true,
      },
      {
        title: "Forma de pago",
        dataIndex: "formaPago",
        key: "formaPago",
        filters: this.state.filtrosFormasPago,
        sorter: (a, b) => {
          const aDesc = a.formaPago?.descripcion || '';
          const bDesc = b.formaPago?.descripcion || '';
          if (aDesc < bDesc) {
            return -1;
          }
          if (aDesc > bDesc) {
            return 1;
          }
          return 0;
        },
        render: (value) => value ? (value.c_FormaPago + ' - ' + value.descripcion) : '-',
        onFilter: (value, record) => record.formaDePagoId?.toString().indexOf(value) === 0,
        width: 150,
        ellipsis: true,
      },
      {
        title: "Fecha",
        dataIndex: "fechaVenta",
        key: "fechaVenta",
        defaultSortOrder: 'descend',
        sorter: true,
        render: (value) => moment(value).locale("es").format("DD/MM/YY HH:mm"),
        width: 120,
        ellipsis: true,
        align: "center",
      },
      {
        title: "Subtotal / Total",
        dataIndex: "subtotal",
        key: "subtotal",
        responsive: ["md"],
        sorter: true,
        buscar: "subtotal",
        render: (_, record) => (
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: "14px", color: "#666" }}>
             {dineroDisabledMask(record.subtotal)} {record.moneda}
            </div>
            <div style={{ fontWeight: "bold", fontSize: "13px" }}>
             {dineroDisabledMask(record.total)} {record.moneda}
            </div>
          </div>
        ),
        width: 150,
        ellipsis: true,
        align: "right",
      },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        sorter: true,
        buscar: "total",
        responsive: [],
        width: 0,
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        responsive: ["md"],
        render: (value) => {
          if (value === 0) {
            return <Tag color="red">Cancelada</Tag>;
          }
          if (value === 1) {
            return <Tag color="blue">Sin entregar</Tag>;
          }
          if (value === 2) {
            return <Tag color="orange">Entregado par.</Tag>;
          }
          if (value === 3) {
            return <Tag color="green">Entregado</Tag>;
          }
        },
        width: 140,
        ellipsis: true,
      },
    ];
    return (
      <>
        <PageHeader
          title={`Factura Global ${(this.state.subtotal !== 0 && this.state.total !== 0) ? (' - Subtotal: ' + dineroDisabledMask(this.state.subtotal) + '  Total: ' + dineroDisabledMask(this.state.total)) : ''}`}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <ButtonItem
              type="primary"
              key="abrirDatosFacturaGlobal"
              onClick={this.abrirDatosFacturaGlobal.bind(this)}
            >
              Datos Factura Global
            </ButtonItem>
          }
        />
        {(() => {
          const avisoState = this.props.location?.state;
          if (!avisoState?.remisionesIds?.length) return null;

          const REMISIONES_LABELS = {
            semanaPasada:   'De la semana pasada',
            semanaActual:   'De la semana actual',
            quincenaPasada: 'De la quincena pasada',
            mesPasado:      'Del mes pasado',
            mesActual:      'Del mes actual',
          };
          const PERIODICIDAD_LABELS = {
            semanal:   'Semanal',
            quincenal: 'Quincenal',
            mensual:   'Mensual',
          };

          const periodoLabel = REMISIONES_LABELS[avisoState.remisiones] || avisoState.remisiones || '—';
          const periodicidadLabel = PERIODICIDAD_LABELS[avisoState.periodicidad] || avisoState.periodicidad || '—';
          const fechaAviso = avisoState.fechaAviso ? moment(avisoState.fechaAviso).format('DD/MM/YYYY HH:mm') : '';
          const totalPreseleccionadas = this.state.ventasSeleccionadas.length;
          const filtros = avisoState.filtros || {};
          const clientesFiltro = filtros.clientes || [];
          const formasPagoFiltro = filtros.formasDePago || [];

          const autoIds = this.state.autoSelectedIds;

          return (
            <div style={{
              background: '#fff',
              border: '1px solid #b5e8f0',
              borderLeft: '4px solid #00BFD6',
              borderRadius: 8,
              padding: '10px 16px',
              marginBottom: 12,
            }}>
              {/* Fila 1: título + info + botones */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8, marginBottom: clientesFiltro.length || formasPagoFiltro.length ? 8 : 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
                  <span style={{ color: '#00BFD6', fontWeight: 700, fontSize: 14, display: 'flex', alignItems: 'center', gap: 6 }}>
                    <ThunderboltOutlined />
                    Automatización activa
                  </span>
                  <span style={{ color: '#555', fontSize: 13 }}>
                    {totalPreseleccionadas} venta{totalPreseleccionadas !== 1 ? 's' : ''} seleccionada{totalPreseleccionadas !== 1 ? 's' : ''}
                  </span>
                  <span style={{ color: '#888', fontSize: 12 }}>{periodoLabel} · {periodicidadLabel}</span>
                  {fechaAviso && <span style={{ color: '#aaa', fontSize: 12 }}>Aviso: {fechaAviso}</span>}
                </div>
                {autoIds.length > 0 && (
                  <Space size="small">
                    <ButtonItem
                      size="small"
                      blanco
                      onClick={() => {
                        const autoSet = new Set(autoIds);
                        const sinAuto = this.state.ventasSeleccionadas.filter(id => !autoSet.has(id));
                        this.onSelectChange(sinAuto);
                      }}
                    >
                      Deseleccionar auto.
                    </ButtonItem>
                    <ButtonItem
                      size="small"
                      type="primary"
                      onClick={() => {
                        const actual = new Set(this.state.ventasSeleccionadas);
                        const nuevos = autoIds.filter(id => !actual.has(id));
                        if (!nuevos.length) return;
                        this.setState({ autoSelecting: true });
                        setTimeout(() => {
                          const union = [...this.state.ventasSeleccionadas, ...nuevos];
                          this.onSelectChange(union);
                          this.setState({ autoSelecting: false });
                        }, 2000);
                      }}
                    >
                      + Añadir auto.
                    </ButtonItem>
                  </Space>
                )}
              </div>
              {/* Fila 2: Clientes */}
              {clientesFiltro.length > 0 && (
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: formasPagoFiltro.length ? 6 : 0, flexWrap: 'wrap' }}>
                  <span style={{ color: '#888', fontSize: 12, fontWeight: 600, minWidth: 76, paddingTop: 2 }}>Clientes:</span>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                    {clientesFiltro.map(c => (
                      <Tag key={c._id} color="cyan" style={{ marginBottom: 0, fontSize: 12 }}>{c.nombre}</Tag>
                    ))}
                  </div>
                </div>
              )}
              {/* Fila 3: Formas de pago */}
              {formasPagoFiltro.length > 0 && (
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, flexWrap: 'wrap' }}>
                  <span style={{ color: '#888', fontSize: 12, fontWeight: 600, minWidth: 76, paddingTop: 2 }}>Formas pago:</span>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                    {formasPagoFiltro.map(f => (
                      <Tag key={f._id} color="geekblue" style={{ marginBottom: 0, fontSize: 12 }}>{f.descripcion}</Tag>
                    ))}
                  </div>
                </div>
              )}
            </div>
          );
        })()}
        <div style={{ position: 'relative' }}>
          {this.state.autoSelecting && (
            <div className="fg-anim-overlay">
              <div className="fg-anim-stage">
                <div className="fg-anim-ring fg-anim-ring-1" />
                <div className="fg-anim-ring fg-anim-ring-2" />
                <div className="fg-anim-ring fg-anim-ring-3" />
                <div className="fg-anim-icon">
                  <ThunderboltOutlined />
                </div>
              </div>
              <p className="fg-anim-text">Seleccionando ventas automáticamente...</p>
            </div>
          )}
          <TableItem
            onRow={(record, rowIndex) => {
              return {
                onDoubleClick: (event) => {
                  this.props.history.push("/panel/verVenta", { id: record._id });
                },
              };
            }}
            rowClassName={(record) =>
              record.contado === 1 && record.totalPagado !== record.totalPagar
                ? "fila-venta-no-cobrada"
                : ""
            }
            loading={this.state.loading}
            size="small"
            dataSource={this.state.todasVentas}
            rowSelection={{
              selectedRowKeys: this.state.ventasSeleccionadas,
              onChange: this.onSelectChange.bind(this),
            }}
            columns={columns}
            pagination={false}
          />
        </div>
        <ModalItem
          title="Datos Factura Global"
          visible={this.state.modalDatosFacturaGlobal}
          spinning={this.state.loading}
          onCancel={this.cerrarDatosFacturaGlobal.bind(this)}
          paddingTop
        >
          <Form
            ref={this.formRef}
            name="datosfacturaGlobal"
            layout
            width={700}
            onCancel={this.cerrarDatosFacturaGlobal.bind(this)}
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <FormItem
              label="Linea por venta"
              name="lineaPorVenta"
              margin
              initialValue={this.state.predefinirGlobalPorLineaVenta}
              valuePropName="checked"
              tooltip="De acuerdo al manual de llenado del CFDI 4.0 del SAT, los conceptos de la factura global deben emitirse desglosados por cada venta (una línea por operación), evitando agruparlos en un solo concepto."
            >
              <SwitchItem />
            </FormItem>
            <FormItem
              label="F. Pago Mayor Venta"
              name="formaPagoMayorVenta"
              margin
              initialValue={this.state.predefinirGlobalPorLineaVenta}
              valuePropName="checked"
              tooltip="De acuerdo al manual de llenado del CFDI 4.0 del SAT, la forma de pago se debe especificar para la venta con mayor importe."
            >
              <SwitchItem />
            </FormItem>
            <FormItem
              label="Fecha de Emisión"
              name="fechaEmision"
              required
              margin
            >
              <DatePickerItem
                showTime={{
                  format: "HH:mm",
                  minuteStep: 1,
                }}
                format="DD/MM/YYYY HH:mm"
                placeholder="Fecha de Emisión"
                allowClear={false}
                disabledDate={(current) => {
                  const now = dayjs();
                  const minDate = now.subtract(72, "hour");
                  const maxDate = now;
                  return current < minDate.startOf("minute") || current > maxDate.endOf("minute");
                }}
                disabledTime={(current) => {
                  const now = dayjs();
                  const minDate = now.subtract(72, "hour");
                  const maxDate = now;

                  // Si la fecha seleccionada está fuera del rango permitido, bloquea todo
                  if (!current || current.isBefore(minDate, "day") || current.isAfter(maxDate, "day")) {
                    return {
                      disabledHours: () => Array.from({ length: 24 }, (_, i) => i),
                    };
                  }

                  return {};
                }}
              />
            </FormItem>
            <FormItem
              label="Proyecto"
              name="proyectoId"
              margin
              required
            >
              <SelectItem
                placeholder="Proyecto"
              >
                {this.state.objetoProyectos}
              </SelectItem>
            </FormItem>
            <FormItem
              label="Periocidad"
              name="periocidadSatId"
              margin
              required
            >
              <SelectItem
                placeholder="Periocidad"
              >
                {this.state.objetoPeriocidadesSat}
              </SelectItem>
            </FormItem>
            <FormItem
              label="Año Periocidad"
              name="anoPeriocidad"
              required
              margin
              initialValue={moment()}
            >
              <DatePickerItem
                dateFormat='YYYY'
                placeholder="Año Periocidad"
                picker="year"
                allowClear={false}
              />
            </FormItem>
            <FormItem
              label="Mes"
              name="mesSatId"
              margin
              required
            >
              <SelectItem
                placeholder="Mes"
              >
                {this.state.objetoMesesSat}
              </SelectItem>
            </FormItem>
            <div style={{ display: "flex", justifyContent: "right", marginTop: 20, marginBottom: 10 }}>
              <Space>
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Agregar Factura Global
                </ButtonItem>
                <ButtonItem
                  type="primary"
                  danger
                  onClick={this.cerrarDatosFacturaGlobal.bind(this)}
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Cancelar
                </ButtonItem>
              </Space>
            </div>
          </Form>
        </ModalItem>
        <MandarCorreoFacturaGlobal
          visible={this.state.modalVerFacturaGlobal}
          id={this.state.modalVerFacturaGlobalId}
          history={this.props.history}
          cerrarMandarCorreoFacturaGlobal={this.cerrarMandarCorreoFacturaGlobal.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    certificada: state.empresa.certificada,
    envios: state.empresa.envios,
    permisoAgregarVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ccb6bf30e81b54183cf70"
      )?.activado,
    permisoCancelarVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6472d37f4b2da7c85c1a8cff"
      )?.activado,
    permisoEntregarInsumosVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ccbaff30e81b54183cf71"
      )?.activado,
  };
};

export default connect(mapStateToProps)(FacturaGlobal);
